import {Action} from "@ngrx/store";
import {ITopPanelStoreValue} from "../../state/top-panel/top-panel.state";

export enum ETopPanelActions {
  ClearParameters = '[TopPanel] Clear stored parameters',
  SetParameter = '[TopPanel] Set new parameter in store',
  RemoveParameter = '[TopPanel] Remove parameter from store',

  SetQueryParameters = '[TopPanel] Set query parameter in store',

}
export class ClearParameters implements Action{
  public readonly type = ETopPanelActions.ClearParameters;
}
export class SetParameter implements Action{
  public readonly type = ETopPanelActions.SetParameter;
  constructor(public payload: ITopPanelStoreValue) {}
}
export class RemoveParameter implements Action{
  public readonly type = ETopPanelActions.RemoveParameter;
  constructor(public payload: string) {}
}
export class SetQueryParameters implements Action{
  public readonly type = ETopPanelActions.SetQueryParameters;
  constructor(public payload: object) {}
}
export type TopPanelActions =
  ClearParameters |
  SetParameter |
  RemoveParameter |
  SetQueryParameters;
